// First sign-in for a teacher listed in SCR Central (#425). When a signed-in user has no LD
// profile, ask the server to create a teacher account. The server decides everything from
// the session and SCR Central; nothing is sent but the access token. Returns true only when
// a profile now exists.
export async function requestTeacherAccess(accessToken: string | undefined | null): Promise<boolean> {
  if (!accessToken) return false;
  try {
    const res = await fetch('/api/teacher-access', {
      method: 'POST',
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!res.ok) return false;
    const body = (await res.json()) as { result?: string };
    return body.result === 'created' || body.result === 'has_profile';
  } catch {
    return false;
  }
}
